import { makePaddingProp } from '@thyme/nashville/src/types/shared'
import { PropType } from 'vue'

const sharedProps = {
  ...makePaddingProp(),
}

export const T_SPINNER_WITH_MESSAGES_PROPS = {
  fullPage: { type: Boolean, default: false },
  partialPage: { type: Boolean, default: false },
  name: { type: String, required: true },
  messages: {
    type: Array as PropType<Array<{ text: string; ms: number }>>,
    required: true,
  },
  ...sharedProps,
} as const

export const SHARED_PROP_KEYS = Object.keys(sharedProps)
